'use strict';

import { Toaster } from 'react-hot-toast';
import { ReactComponent as LogoSvg } from './new/assets/logo.svg';
import { RawUser, useUser } from './new/hooks/use-user';
import { RouteComponent } from 'react-router';
import { InfluencerIdProvider } from './new/contexts/InfluencerIdContext';
import { PortalUser } from '@playbook-technologies/common-enums';
import { useEffect, useState } from 'react';
import { trackSessionEvent } from '@services/session-tracker/sessionTracker';

const Application: RouteComponent = ({ children, params }) => {
  const { isLoading, user } = useUser();
  const [prevUser, setPrevUser] = useState<RawUser>(null);
  useEffect(() => {
    if (JSON.stringify(prevUser) === JSON.stringify(user)) return;
    setPrevUser(user);
    if (user?.id)
      trackSessionEvent('Login', {
        influencerId: user.influencerId,
        userEmail: user.email,
        userId: user.id,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const influencerId: number | undefined =
    user.role === PortalUser.Role.Influencer.value
      ? user.influencerId
      : parseInt(params.influencerId);

  const pathname = window.location.pathname;
  const needsInfluencerId =
    pathname.startsWith('/admin/partner/') || pathname.startsWith('/creator/');

  if (needsInfluencerId && influencerId === undefined) {
    throw new Error('influencerId not set in routing params');
  }

  return (
    <InfluencerIdProvider value={influencerId ?? 0}>
      <div id="application" className="application">
        <div>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 5000,
              style: {
                maxWidth: '700px',
              },
            }}
          />
        </div>
        <>
          {isLoading ? (
            <div className="flex items-center justify-center min-h-screen animate-pulse antialiased">
              <LogoSvg className="w-auto h-14 flex-no-shrink fill-current" />
            </div>
          ) : (
            children
          )}
        </>
      </div>
    </InfluencerIdProvider>
  );
};

export default Application;
